import React from "react";

export function useResizeObserver(args: {
  ref: React.RefObject<HTMLElement>;
  onResize?: (size: { width: number; height: number }) => void;
  deps?: React.DependencyList;
}) {
  React.useLayoutEffect(() => {
    if (!args?.ref?.current || !("ResizeObserver" in window)) return;

    const handleResize = () => {
      args?.onResize?.({
        width: args?.ref?.current?.offsetWidth || 0,
        height: args?.ref?.current?.offsetHeight || 0,
      });
    };

    window.addEventListener("resize", handleResize);

    // Use ResizeObserver for better detection
    let resizeObserver: ResizeObserver | null = null;
    if (args?.ref?.current && "ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(() => {
        args?.onResize?.({
          width: args?.ref?.current?.offsetWidth || 0,
          height: args?.ref?.current?.offsetHeight || 0,
        });
      });
      resizeObserver.observe(args?.ref?.current);
    }

    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, args?.deps || []);
}
